export default "__VITE_ASSET__DDI2x388__"